<template>
  <div class="bg-white">
    <div class="font-gotham-bold">
      <ul role="list" class="grid grid-cols-1 gap-4 sm:gap-4 lg:grid-cols-3">
        <li v-for="contractOption in contractOptions" @click="emit('onContractSelected', contractOption.id);" :key="contractOption.name" class="transition duration-250 group col-span-1 flex shadow-sm rounded-2xl cursor-pointer border border-solid" :class="[ selected === contractOption.id ? 'border-black' : 'border-gray-200' ]">
          <div
            class="flex-1 flex items-center justify-between bg-white rounded-2xl truncate"
            >
            <div class="flex-1 px-8 py-2 text-lg truncate">
              <p class="text-xl transition duration-250 text-black font-extrabold">{{ utilityService.toTitleCase(contractOption.name) }} Contract.</p>
              <p :class="['text-sm transition duration-250', contractOption.displayDiscount ? 'text-decoration-line: line-through text-gray-300' : 'text-gray-900']">{{ activationFee(contractOption, false) }}</p>
              <p class="text-sm transition duration-250 text-gray-900" v-if="contractOption.displayDiscount">{{ activationFee(contractOption, true) }}</p>
            </div>
            <div class="flex-shrink-0 pl-4 pr-4 flex items-center justify-center">
              <button type="button" class="w-10 h-10 bg-white inline-flex items-center justify-center rounded-full bg-transparent border-none"
                :class="[ selected === contractOption.id ? 'text-black' : 'text-gray-600 group-hover:text-gray-400' ]"
                >
                <CheckCircleIcon v-if="selected === contractOption.id" class="w-10 h-10" aria-hidden="true" />
              </button>
            </div>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script setup lang='ts'>
import { injectStrict } from '../../plugins/vueServiceContainerPlugin';
import { UtilityServiceInterface } from '@/services/utilityServiceInterface';
import { CheckCircleIcon } from '@heroicons/vue/outline';
import { defineProps, defineEmits } from 'vue';

const utilityService = injectStrict<UtilityServiceInterface>('UtilityServiceInterface');

type ContractOption = {
  id: string,
  name: string,
  description: string,
  price: number,
  discountedPrice?: number,
  displayDiscount?: boolean,
}

defineProps<{
  contractOptions: Array<ContractOption>,
  selected: string
}>();

const emit = defineEmits<{(e: 'onContractSelected', id: string): void}>();

const activationFee = (contractOption: ContractOption, discounted: boolean): string => {
  if (discounted) {
    if (contractOption.discountedPrice === 0) {
      return 'Free Activation';
    } else {
      return `$${contractOption.discountedPrice} Activation Fee`;
    }
  }
  return `$${contractOption.price} Activation Fee`;
};
</script>
